import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

export default function SupportWidgetController() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};

    if (isAdmin) {
      document.documentElement.classList.add('hide-tawk-chat');
      document.body.classList.add('hide-tawk-chat');

      if (typeof window.Tawk_API.hideWidget === 'function') {
        try {
          window.Tawk_API.hideWidget();
        } catch (e) {
          console.warn('Tawk hideWidget error:', e);
        }
      } else {
        const prevOnLoad = window.Tawk_API.onLoad;
        window.Tawk_API.onLoad = function () {
          if (typeof prevOnLoad === 'function') prevOnLoad();
          try {
            if (window.location.pathname.startsWith('/admin') && typeof window.Tawk_API.hideWidget === 'function') {
              window.Tawk_API.hideWidget();
            }
          } catch (e) {}
        };
      }
    } else {
      document.documentElement.classList.remove('hide-tawk-chat');
      document.body.classList.remove('hide-tawk-chat');

      if (typeof window.Tawk_API.showWidget === 'function') {
        try {
          window.Tawk_API.showWidget();
        } catch (e) {
          console.warn('Tawk showWidget error:', e);
        }
      } else {
        const prevOnLoad = window.Tawk_API.onLoad;
        window.Tawk_API.onLoad = function () {
          if (typeof prevOnLoad === 'function') prevOnLoad();
          try {
            if (!window.location.pathname.startsWith('/admin') && typeof window.Tawk_API.showWidget === 'function') {
              window.Tawk_API.showWidget();
            }
          } catch (e) {}
        };
      }
    }
  }, [isAdmin, location.pathname]);

  if (isAdmin) {
    return null;
  }

  return <WhatsAppButton />;
}
